<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a">
      <div class="venueStyle__pages__3golT undefined venueStyle__ty__3em5P" style="background-image: url(/static/image/bg.ad71d5e9d0a5ee6c91cc85f3664b5c43.jpg); height: 800px">
        <div class="venueStyle__content__37kNp" v-if="$store.state.lotteryList.length > 0">
          <div class="venueStyle__contentLeft__3bmvb" v-for="(item, index) in $store.state.lotteryList" :key="index" v-if="type == index">
            <img :src="item.api_logo_img"  width="449.2px" class="venueStyle__title__K3KhH" style="width: 450px; min-height: 124px; opacity: 1; margin-left: 0px" /><span class="venueStyle__subTitle__2nKwg"
              >顶尖旗舰平台，最全热门彩种，玩法多样操作简洁，实时助运，稳添好彩！
              <ul class="venueStyle__icons__kTABJ"></ul>
            </span>

            <a id="gotogames" class="gotogames" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"><img src="/static/image/btn.1cfd2c8e17e20f1631dd11d7504e717d.png" width="176px" class="venueStyle__btn__HuPwB" style="margin-top: 25px; margin-left: -3px" /> </a>
          </div>
          <div class="venueStyle__models__zXaM0"><img :src="`/static/image/lottery/${type%3}.png`" width="800px" class="" style="margin-left: -28px; opacity: 1" /></div>

          <ul class="venueStyle__tabs__3wTus" style="margin-left: -132px">
            <li class="venueStyle__tabItem__11CR_" v-for="(item, index) in $store.state.lotteryList" :key="index" @click="changType(index)">
              <img v-if="type == index" :src="item.check_yes_img" width="180px" style="" />
              <img v-else :src="item.check_no_img" width="180px" style="" />
            </li>
          </ul>
          <img src="/static/image/anm-ob-1.d0e64c5d9fd540a1f25a656de257a401.png" width="120px" class="venueStyle__anm__3WJmq xf_img1" style="left: 476px; top: 105px" />
          <img src="/static/image/anm-ob-2.bbb58f7a43dc0352e1530b268f5acbae.png" width="64px" class="venueStyle__anmTwo__1r2lK xf_img2" style="left: 611px; top: 212px" />
          <img src="/static/image/anm-ob-3.ec4795248988cc8a3ed653531aa6cd3a.png" width="64px" class="venueStyle__anm__3WJmq xf_img3" style="left: 936px; top: 103px" />
          <img src="/static/image/anm-ob-4.1fad548a4ab1420cc072472677e1bc72.png" width="70px" class="venueStyle__anmTwo__1r2lK xf_img4" style="left: 999px; top: 171px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'lottery',
  data() {
    return {
      type: 0,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    changType(index) {
      let that = this;
      that.type = index;
    },
  },
  mounted() {
    let that = this;
    $('.venueStyle__title__K3KhH ').css({ 'margin-left': '-68px' });
    $('.venueStyle__title__K3KhH ').animate({ 'margin-left': '-0px' }, 400);
    $('.gotogames img ').css({ 'margin-left': '-128px' });
    $('.gotogames img ').animate({ 'margin-left': '-0px' }, 400);
    $('.venueStyle__subTitle__2nKwg ').css({ 'margin-left': '-128px' });
    $('.venueStyle__subTitle__2nKwg ').animate({ 'margin-left': '-0px' }, 200);
    $('.venueStyle__models__zXaM0 img').css({ 'margin-left': '-28px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'margin-left': '-108px' }, 400);
  },
  updated() {
    let that = this;
    $('.venueStyle__title__K3KhH ').css({ 'margin-left': '-68px' });
    $('.venueStyle__title__K3KhH ').animate({ 'margin-left': '-0px' }, 400);
    $('.gotogames img ').css({ 'margin-left': '-128px' });
    $('.gotogames img ').animate({ 'margin-left': '-0px' }, 400);
    $('.venueStyle__subTitle__2nKwg ').css({ 'margin-left': '-128px' });
    $('.venueStyle__subTitle__2nKwg ').animate({ 'margin-left': '-0px' }, 200);
    $('.venueStyle__models__zXaM0 img').css({ 'margin-left': '-28px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'margin-left': '-108px' }, 400);
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '/static/css/Lottery_793450d6.8907158d.css';
//@import '/style.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/lottery.vue